import { defineInterface } from '@nzyme/ioc/Interface.js';
export const AppConfig = defineInterface({
    name: 'AppConfig',
});
//# sourceMappingURL=AppConfig.js.map